import classNames from 'classnames';
import { Icon, IconsEnum } from 'components/Icons';
import { CarrelloCombinazioni } from 'features/carrello/carrelloCombinazioni';
import { useGetLabelByKey, useGetLabelsByKeys } from 'hooks/useLingUI';
import { useState } from 'react';
import styles from './CarrelloCombinazioniDesktop.module.scss';

export const CarrelloCombinazioniDesktop = () => {
  const [labelEspandi, labelRiduci] = useGetLabelsByKeys(['espandi', 'riduci']);
  const [openCombinazioni, setOpenCombinazioni] = useState<boolean>(true);
  const [isFullCombinazioni, setIsFullCombinazioni] = useState<boolean>(false);
  const labelCombinazioni = useGetLabelByKey('combinazioni-sistema');

  const handleCloseCombinazioni = () => {
    setOpenCombinazioni(!openCombinazioni);
    if (isFullCombinazioni) {
      setIsFullCombinazioni(false);
    }
  };

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.fullHeight]: isFullCombinazioni,
      })}
    >
      <div className={styles.header}>
        <div className={styles.buttonContainer} onClick={handleCloseCombinazioni}>
          <Icon
            iconId={openCombinazioni ? IconsEnum.CHEVRON_UP : IconsEnum.CHEVRON_DOWN}
            color="var(--color-primary)"
            className={styles.icon}
          />
          <div className={styles.text}>{labelCombinazioni}</div>
        </div>
        {openCombinazioni && (
          <div className={styles.button} onClick={() => setIsFullCombinazioni(!isFullCombinazioni)}>
            {isFullCombinazioni ? labelRiduci : labelEspandi}
          </div>
        )}
      </div>
      {openCombinazioni && <CarrelloCombinazioni />}
    </div>
  );
};
